function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M47.9 13.7V4.3H16.7c-.3 0-.7.1-.9.3l-3 2.5-6.5 5.5-2.4 2c-.3.3-.5.7-.5 1.1v43.9H48V34.7l-3 3.8v18.4H6.2V17.2h10.5c.8 0 1.4-.6 1.4-1.4V7.2H45v10.4l2.9-3.9zm-32.7.7H8.7l6.5-5.5v5.5z",
  fill: "#717375"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2 25.3l-1.4 1.8H11.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h28.1zm-7.5 10.4l-.9 1.8H11.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h20.6zm-3.8 12.1H11.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h16.7c.5 0 .9.4.9.9.1.5-.3.9-.8.9zM60.5 19l-7.9 10.5c-.3.4-.8.4-1.2.2-.4-.3-.4-.8-.2-1.2l7-9.3-1.2-.9-16.3 21.8c-.6.8-2.3 2.4-4.1 3.7h-.1c-1.4 1-2.9 1.8-3.8 1.7l-.9 1.2c-.2.3-.6.3-.9.1-.3-.2-.3-.6-.1-.9l.9-1.2c-.3-.9 0-2.5.6-4.2.7-2 1.8-4.1 2.4-4.9l17.1-22.8c.6-.8 1.5-1.3 2.5-1.5.5-.1 1 0 1.5.1l1.4-1.8c.4-.6 1.3-.7 1.9-.3.3.2.5.5.5.9 0 .3 0 .7-.3 1L58 13.1c.8 1.3.8 2.9-.2 4.2l1.2.9.2-.2c.3-.4.8-.4 1.2-.2.2.1.3.3.3.6 0 .1-.1.4-.2.6z",
  fill: "#717375"
});

function SvgContract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default SvgContract;